import { buttonVariants, cn, Popover, PopoverContent, PopoverTrigger } from '@patchbay/ui'
import { useQuery } from '@tanstack/react-query'
import { Link2 } from 'lucide-react'
import * as React from 'react'
import { cardLinksQuery, caseLinksQuery, type LinkKind } from './api'
import { LinksState } from './links-list'

/**
 * "Links" on the next-move strip and in the Update panel's next-move suggestions (issue #274): every deep link the
 * case's records support (Conduit, NinjaOne, UniFi, the PBX, Desk, phone numbers), fetched when it opens. With
 * `cardId` it shows only the links that task needs. The server already dropped what the viewer's role may not see.
 */
export function CaseLinksPopover({
  caseId,
  cardId,
  kinds,
  label = 'Links',
  className,
}: {
  caseId: string
  cardId?: string
  kinds?: readonly LinkKind[]
  label?: string
  className?: string
}) {
  const [open, setOpen] = React.useState(false)
  const q = useQuery({
    ...(cardId ? cardLinksQuery(caseId, cardId) : caseLinksQuery(caseId, kinds)),
    enabled: open,
  })
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger
        type="button"
        aria-label={cardId ? 'Links for this task' : 'Links for this case'}
        title="Deep links built from the records we hold"
        className={cn(buttonVariants({ variant: 'ghost', size: 'sm' }), className)}
        data-slot="links-trigger"
      >
        <Link2 /> {label}
      </PopoverTrigger>
      <PopoverContent className="max-h-[70vh] w-80 overflow-y-auto" align="end">
        <LinksState q={q} />
      </PopoverContent>
    </Popover>
  )
}
